import { CacheScenario, CacheTime, MethodType } from '../models/api/cache';
import { API_ENDPOINT } from './utils.service';

export const sparePartsServiceCache: () => CacheScenario[] = (): CacheScenario[] => [
  {
    description: 'method getSparePartsTypes, caching types of spare parts',
    cacheTime: CacheTime.DEFAULT,
    endpoint: {
      url: `${API_ENDPOINT}/spareParts/types`,
      method: MethodType.GET,
    },
    cleaningEndpoints: [
      {
        url: `${API_ENDPOINT}/spareParts`,
        method: MethodType.PUT,
      },
      {
        url: `${API_ENDPOINT}/spareParts/import`,
        method: MethodType.PUT,
      },
      {
        url: `${API_ENDPOINT}/spareParts/deleteMany`,
        method: MethodType.POST,
      },
    ],
  },
];
